import { Box, IconButton, TextField, Button, Typography  } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
import { get, post } from "api/apiBridges/httpBridge";
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { useLocalNotifications } from "components/Events";
import ClassicSearch from "components/classicSearch";
import SaveIcon from '@mui/icons-material/Save';

export function BarcodeSettings() {
    const ds = useMemo(() => getDataSource('ClientBarcodes'), []);
    const [rawData, setRawData] = useState([]);
    const { user_id, company_id } = useSelector(loginSelector);
    const { market } = useSelector(MarketClientSelector);
    const [loading, setLoading] = useState(false);

    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState("");
    const [filterFields, setFilterFields] = useState({
        title: { name: "Название", active: true },
        brand: { name: "Брэнд", active: true },
        vendorCode: { name: "Артикул", active: true },
        barcode: { name: "ШК", active: true },
    });

    const [allBarcodesCustom, setAllBarcodesCustom] = useState([]);
    const [allBarcodesOzon, setAllBarcodesOzon] = useState([]);
    const [allBarcodesWB, setAllBarcodesWB] = useState([]);

    const { showNotification } = useLocalNotifications();
    
    const fetchData = useCallback(async (isInitial = false) => {
        if (isInitial) setLoading(true);
        
        try {
            let cardCustom = await get("custom_product/getOnCli", {cid:user_id})
            const allBarcodesCustom = cardCustom.reduce((acc, item) => {const barcodes = item.data?.sizes?.map(size => size.barcode) || [];
                return acc.concat(barcodes);
            }, []);
            //console.log(allBarcodesCustom)
            let cardOzon = await ds.getOZONCardAndStocks(user_id)
            const allBarcodesOzon = (cardOzon).reduce((acc, item) => {const barcodes = item.data?.sizes?.map(size => size.barcode) || [];
                return acc.concat(barcodes);
            }, []);

            let cardWB = await ds.getWBCardAndStocks(user_id)
            const allBarcodesWB = (cardWB).reduce((acc, item) => {const barcodes = item.data?.sizes?.map(size => size.barcode) || [];
                return acc.concat(barcodes);
            }, []);
            
            const savedBarcodes = await get('Barcode_search/getBarcode', { uid: user_id }) || [];
            const savedCustom = savedBarcodes.map(item => item.custom_barcode).filter(Boolean);
            const savedOzon = savedBarcodes.map(item => item.ozon_barcode).filter(Boolean);
            const savedWB = savedBarcodes.map(item => item.wb_barcode).filter(Boolean);
            const mergedCustom = Array.from(new Set([...allBarcodesCustom, ...savedCustom]));
            const mergedOzon = Array.from(new Set([...allBarcodesOzon, ...savedOzon]));
            const mergedWB = Array.from(new Set([...allBarcodesWB, ...savedWB]));

            const barcodeMap = {};
            savedBarcodes.forEach(item => {
                if (item.wb_barcode) barcodeMap[item.wb_barcode] = item;
                if (item.ozon_barcode) barcodeMap[item.ozon_barcode] = item;
                if (item.custom_barcode) barcodeMap[item.custom_barcode] = item;
            });

            console.log('SAVED BARCODES', savedBarcodes)

            let res = [];
            if (market !== "custom") {
                const isToken = await get('Clients/checkClientAPIKey', { uid: user_id, market: market });
                if (isToken) {
                    res = market === "wb" ? cardWB : cardOzon
                } else {
                    showNotification({ id: 'checkToken', type: 'error', message: 'API ключ не найден.' });
                }
            } else {
                res = cardCustom
            }

            const flatData = [];
                res.forEach((el) => {
                    el.data.sizes.forEach((size) => {
                        flatData.push({
                            ...el,
                            id: `${el.nmID || size.nmID};${size.barcode}`,
                            size: { ...size, stocks: size.stocks?.sort((a, b) => b.stocks - a.stocks), countQr: size.countQr || 0 },
                            mappingData: {
                                baseBarcode: size.barcode,
                                savedRecord: barcodeMap[size.barcode] || null,
                                allBarcodesCustom: mergedCustom,
                                allBarcodesOzon: mergedOzon,
                                allBarcodesWB: mergedWB,
                            },
                            techTask: { ...size.techTask, barcode: size.barcode, title: el.data.title, vendorCode: el.data.vendorCode },
                            expanded: undefined
                        });
                    });
                });

            setAllBarcodesCustom(mergedCustom);
            setAllBarcodesOzon(mergedOzon);
            setAllBarcodesWB(mergedWB);

            setRawData(market === "custom" ? flatData.sort((a, b) => b.nmID - a.nmID) : flatData);
        } catch (error) {
            console.error("Fetch error", error);
        } finally {
            setLoading(false);
        }
    }, [ds, market, user_id]);
    useEffect(() => {
        if (user_id) {
            fetchData(true);
        }
    }, [market, user_id]);

    const filteredData = useMemo(() => {
        if (!checked || !filter) return rawData;
        const tf = filter.toLowerCase();
        return rawData.filter((el) => {
            const baseBarcode = el?.mappingData?.baseBarcode;
            const saved = el?.mappingData?.savedRecord;
            return (
                (filterFields.title.active &&
                    String(el.data.title || "").toLowerCase().includes(tf)) ||
                (filterFields.brand.active &&
                    String(el.data.brand || "").toLowerCase().includes(tf)) ||
                (filterFields.vendorCode.active &&
                    String(el.data.vendorCode || "").toLowerCase().includes(tf)) ||
                (filterFields.barcode.active &&
                    (
                        String(baseBarcode || "").toLowerCase().includes(tf) ||
                        String(saved?.wb_barcode || "").toLowerCase().includes(tf) ||
                        String(saved?.ozon_barcode || "").toLowerCase().includes(tf) ||
                        String(saved?.custom_barcode || "").toLowerCase().includes(tf)
                    ))
            );
        });
    }, [rawData, checked, filter, filterFields]);

    if (loading && rawData.length === 0) return <Loading />;

    return (
        <Box sx={{ height: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: "space-between", height: '10%' }}>
                <ClassicSearch 
                    setChecked={setChecked} 
                    setFilter={setFilter} 
                    checked={checked}
                    fields={filterFields} 
                    setFields={setFilterFields}
                />
            </div>
            <Scrollbars autoHeight autoHeightMax={"79vh"} style={{ width: '100%' }}>
                <div style={{ paddingBottom: '20px', opacity: loading ? 0.7 : 1, transition: 'opacity 0.2s' }}>
                    <ReportTable
                        ds={ds}
                        data={filteredData}
                        autoPagination={15}
                    />
                </div>
            </Scrollbars>
        </Box>
    );
}